export default "__VITE_ASSET__DmLi2qIf__"